
import Vue from 'vue';
import VixModal from '@mx/vix/modal/modal';
import { api } from '@/common';
import toast from '@/service/toast'

export default Vue.extend({
  props: {
    dialogConfig: {
      type: Object,
      default: () => {
        return {
          title: '',
          detail: '',
          agreement_name: '',
          up_btn: '',
          down_btn: '',
          agreement_url: '',
          params: {
            productType: 1
          }
        };
      }
    }
  },
  data() {
    return {
      show: true
    };
  },
  components: {
    VixModal
  },
  computed: {
    modalConfig() {
      return {
        title: (this as any).dialogConfig.title,
        large: true,
        className: 'modal-agreement',
        button: [
          {
            text: (this as any).dialogConfig.down_btn,
            onClick: (this as any).cancel
          },
          {
            text: (this as any).dialogConfig.up_btn,
            onClick: (this as any).signAgreement
          }
        ]
      };
    }
  },
  methods: {
    // 去协议页
    toAgreement() {
      this.$bridge.openPage((this as any).dialogConfig.agreement_url);
    },
    // 签署协议
    signAgreement() {
      (this as any).show = false;
      api
        .signAgreement(
          `/api/wallet/touch-sign?productType=${
            (this as any).dialogConfig.params.productType
          }`
        )
        .then(() => {
          toast.show('success', '服务已升级');
        });
    },
    // 暂不升级，关闭弹窗
    cancel() {
      (this as any).show = false;
    }
  }
});
